import { SelectOption } from '@kep-ui-kit/ui-components';

import { StyledFormGroup, StyledSelectMenu } from '@selfserve/react-ui';
import { IIndexSignature } from '@selfserve/react-utils';
import { PlanItem } from '@selfserve/react-common-data';

import { PlanType } from '../data';

interface Props {
  group_items: Array<PlanItem>;
  addons: IIndexSignature<PlanType>;
  addOnName: string;
  selectOptions: Array<SelectOption>;
  handleDropdownChange: (name: string) => (key: string) => void;
}

export const AddonDropdown = ({
  group_items,
  addons,
  addOnName,
  selectOptions,
  handleDropdownChange,
}: Props) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {group_items?.map(({ name }) => {
      const value = String(addons[addOnName || '']?.quantity);
      return (
        <StyledFormGroup withPadding withoutMargin key={name}>
          <StyledSelectMenu
            className="p-dropdown"
            options={selectOptions}
            name={addOnName}
            defaultValue={value}
            value={value}
            onChange={handleDropdownChange(name as string)}
            isSmall
          />
        </StyledFormGroup>
      );
    })}
  </>
);
